import { useCallback, useEffect, useState } from 'react';
import { ParkingQueueEntry } from '../../types/parkingQueue';
import { parkingQueueApi } from '../../api/parkingQueueApi';

export interface UseAllParkingQueueEntriesReturn {
    entries: ParkingQueueEntry[];
    loading: boolean;
    error: string | null;
}

/**
 * Every queue entry, loaded once, without the labels and config of
 * `useParkingQueue`: Hyresgäster reads each tenant's entries from it, so
 * switching tenant needs no new read. Admin-only root: `enabled: false` skips it.
 */
export const useAllParkingQueueEntries = (enabled: boolean): UseAllParkingQueueEntriesReturn => {
    const [entries, setEntries] = useState<ParkingQueueEntry[]>([]);
    const [loading, setLoading] = useState(enabled);
    const [error, setError] = useState<string | null>(null);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            setEntries(await parkingQueueApi.getAll());
        } catch (err) {
            console.error('Error loading queue entries:', err);
            setError('Kunde inte ladda köplatser');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (enabled) {
            load();
        } else {
            setEntries([]);
            setLoading(false);
        }
    }, [enabled, load]);

    return { entries, loading, error };
};
